'use strict';

angular.module('app.common')

  .directive('howToSellButton', [ '$document', '$timeout', function($document, $timeout) {
    function link(scope, element, attrs) {
      scope.gaEventPagename = attrs.gaEventPagename + ' Page';
      $timeout(function() {
        angular.element($document).foundation('reveal');
      }, 0);
    }

    return {
      restrict: 'E',
      scope: true,
      templateUrl: 'app/common/directives/howtosellbutton/howToSellButton.html',
      link: link
    }
  } ]);



// WEBPACK FOOTER //
// ./app/common/directives/howtosellbutton/howToSellButton.js